module.exports = __webpack_public_path__ + "static/media/schedule-library.166c0cfe.png";